import React from 'react';
import { Link } from "react-router-dom";
import '../assets/css/careers.css';
import {Table} from 'reactstrap';

export default class SubmitApplication extends React.Component {
    render() {
        return (
            <div>
                <div className="about">
                    
                    <div className="body white-text">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-7 col-xl-7">
                                    <h2 className="bold">Apply Here</h2>
                                    <div className="card black-text apply">
                                        {/* <p className="bold">CREDIT RATING</p>
                                        <hr />
                                        <br /> */}
                                            <form onSubmit={this.onSubmit}>
                                                {/* <div className="form-inline float-md-right"> */}
                                                    <p className="">FIRST NAME</p>
                                                    <input type='text' placeholder="Enter Firstname" value={this.password} onChange={this.onChange} id='query' />
                                                    <p className="">LAST NAME</p>
                                                    <input type='text' placeholder="Enter Lastname" value={this.password} onChange={this.onChange} id='query' />
                                                    <p className="">EMAIL</p>
                                                    <input type='text' placeholder="Enter Email" value={this.password} onChange={this.onChange} id='query' />
                                                    <p className="">TELEPHONE</p>
                                                    <input type='text' placeholder="Enter Telephone" value={this.password} onChange={this.onChange} id='query' />
                                                    <p className="">CV</p>
                                                    <input type='file' onChange={this.onChange} id='query' style={{border: 'none', paddingLeft: 0}}/>
                                                    <p className="">COVER LETTER</p>
                                                    <textarea type='text' name="message" rows="6" cols="33" />
                                                    <button type='submit' className='bluebutton'>SUBMIT</button>
                                                {/* </div> */}
                                            </form>                                       
                                    </div>
                                    <br />
                                    
                                </div>
                                <div className='d-sm-none d-md-block col-md-5 col-xl-5'>
                                
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}